<script setup lang="ts">
import ReportMetricTooltip from "@/components/datascience/ReportMetricTooltip.vue";
import FloatingTooltip from "@/components/ui/FloatingTooltip.vue";
import type { MetricDtoViewModel } from "@/models";
import { smartToFixed } from "@/services/utils";

const { metric } = defineProps<{
  metric: MetricDtoViewModel;
}>();
</script>

<template>
  <div class="metric text-base-regular">
    <div class="name">
      <ReportMetricTooltip :metric="metric" />

      {{ metric.verbose_name.replace(" - MEAN", "") }}

      <span v-if="metric.greater_is_better !== null" class="favorability text-base-regular">
        <FloatingTooltip
          :text="metric.greater_is_better ? 'Higher is better' : 'Lower is better'"
          strategy="absolute"
        >
          <i
            class="icon"
            :class="metric.greater_is_better ? 'icon-ascending-arrow' : 'icon-descending-arrow'"
          />
        </FloatingTooltip>
      </span>
    </div>
    <div class="value number">
      {{ smartToFixed(metric.value) }}

      <span v-if="metric.std !== null" class="std text-base-medium number">
        <span class="number">±{{ smartToFixed(metric.std) }}</span>
      </span>

      <span v-else-if="metric.versusMean !== null" class="mean text-xs-regular">
        vs&nbsp;mean&nbsp;
        <span class="number">{{ smartToFixed(metric.versusMean) }}</span>
      </span>
    </div>
  </div>
</template>

<style scoped>
.metric {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: var(--numbers-8);
  border: var(--stroke-width-md) solid var(--border-tertiary);
  border-radius: var(--numbers-12);

  .name {
    flex: 1;

    .favorability {
      position: relative;
      color: var(--border-secondary);
      vertical-align: middle;
    }
  }

  .value {
    span {
      white-space: nowrap;
    }

    .std {
      color: var(--content-brand);
    }

    .mean {
      color: var(--content-tertiary);
      vertical-align: middle;
    }
  }
}
</style>
